<template>
  <v-form v-model="formValid" ref="form">
    <v-tabs v-model="tab" height="40">
      <v-tab>Details</v-tab>
      <!-- <v-tab>Employment</v-tab> -->
      <v-tab>Picture</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-container class="pa-0">
        <v-tab-item>
          <v-row>
            <v-col cols="12">
              <v-text-field
                filled
                label="First name"
                v-model="item.firstName"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                filled
                label="Last name"
                v-model="item.lastName"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                filled
                type="email"
                label="Email"
                v-model="item.email"
                :rules="[rules.required, rules.email]"
                hint="Invite will be sent to this email address"
                :persistent-hint="item.id === undefined"
                :disabled="item.id !== undefined"
              ></v-text-field>

              <v-select
                v-if="!isOwner"
                :items="subscriptions"
                label="Select roles"
                filled
                multiple
                v-model="selectedRoles"
                :rules="[rules.hasAtLeastOneElement]"
                :hide-details="selectedRoles.length > 0"
              >
                <template v-slot:prepend-item>
                  <v-row class="px-8">
                    <v-spacer></v-spacer>
                    <v-list-item-action-text class="mx-2"
                      >Viewer</v-list-item-action-text
                    >
                    <v-list-item-action-text class="mx-2"
                      >Admin</v-list-item-action-text
                    >
                  </v-row>
                </template>
                <template v-slot:item="{ item }">
                  <v-list-item class="mr-4">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                        item.subtitle
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="mr-3">
                      <v-checkbox
                        v-if="roleHasSelectedParentDependency(item.adminRole)"
                        v-model="selectedRoles"
                        :value="getRoleParentDependency(item.adminRole)"
                        :disabled="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-else-if="
                          roleHasSelectedParentDependency(item.viewerRole)
                        "
                        v-model="selectedRoles"
                        :value="getRoleParentDependency(item.viewerRole)"
                        :disabled="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-else-if="selectedRoles.includes(item.adminRole)"
                        v-model="selectedRoles"
                        :value="item.adminRole"
                        :disabled="selectedRoles.includes(item.adminRole)"
                      ></v-checkbox>

                      <v-checkbox
                        v-else
                        v-model="selectedRoles"
                        :value="item.viewerRole"
                        :disabled="
                          roleHasSelectedParentDependency(item.viewerRole)
                        "
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-checkbox
                        v-if="roleHasSelectedParentDependency(item.adminRole)"
                        v-model="selectedRoles"
                        :value="getRoleParentDependency(item.adminRole)"
                        :disabled="true"
                      ></v-checkbox>
                      <v-checkbox
                        v-else
                        v-model="selectedRoles"
                        :value="item.adminRole"
                        :disabled="
                          roleHasSelectedParentDependency(item.adminRole)
                        "
                      ></v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-select>

              <v-chip-group v-if="!isOwner">
                <v-chip
                  v-for="(role, idx) in selectedRoles"
                  :key="role.id + '-' + idx"
                  color="primary"
                  outlined
                  @click:close="removeSelectedRole(role)"
                  close
                  >{{ nameForRole(role) }}</v-chip
                >
              </v-chip-group>
              <v-chip v-else color="primary" outlined>Owner</v-chip>
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- <v-tab-item>
          <employment-details-form
            :jobTitle.sync="item.jobTitle"
            :startDate.sync="item.startDate"
            :mobile.sync="item.mobile"
            :landline.sync="item.landline"
          ></employment-details-form>
        </v-tab-item> -->
        <v-tab-item>
          <image-upload
            @removeImage="imageToRemove"
            :imageURL.sync="item.avatarURL"
            :imagePreview.sync="imagePreview"
          ></image-upload>
        </v-tab-item>
      </v-container>
    </v-tabs-items>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageUpload from '@/components/ImageUpload.vue'

export default {
  name: 'NewEmployeeView',
  components: {
    ImageUpload,
  },
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    extraData: {
      type: Object,
      default: () => ({ imagePreview: {} }),
    },
  },
  data() {
    return {
      formValid: false,
      tab: 0,
      rules: {
        required: (value) => !!value || 'Required',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        hasAtLeastOneElement: (value) =>
          value?.length > 0 || 'Select at least 1 role',
      },
      selectedRoles: [],
      imagePreview: {},
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'activeSubscription',
      'companyRoles',
      'clickworkProducts',
      'companyId',
    ]),
    item() {
      return this.editedItem
    },
    isOwner() {
      const ownerRole = this.selectedRoles.find(
        (r) => r.name === 'company-owner'
      )
      return ownerRole !== undefined
    },
    subscriptions() {
      return (
        this.activeSubscription?.products
          .map((prodRef) => {
            return {
              ...this.productForSubscription(prodRef),
              adminRole: this.adminRoleForSubscription(prodRef),
              viewerRole: this.viewerRoleForSubscription(prodRef),
            }
          })
          .sort((a, b) => {
            if (a.listOrder > b.listOrder) {
              return 1
            } else if (a.listOrder < b.listOrder) {
              return -1
            }
            return 0
          }) ?? []
      )
    },
  },
  mounted() {
    this.loading = true
    this.selectedRoles =
      this.item.roles?.map((userRole) => {
        let rolePath = typeof userRole === 'string' ? userRole : userRole.path
        return this.companyRoles.find((cRole) => cRole.ref.path === rolePath)
      }) ?? []

    this.loading = false
  },
  watch: {
    formValid(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$emit('formStateChange', newValue)
      }
    },
    selectedRoles: {
      handler: function (newValue) {
        const roles = []
        roles.push(...newValue.map((role) => role.ref.path))

        newValue.forEach((role) => {
          const deps = this.getDependencyRoles(role)
          roles.push(...deps.map((r) => r.ref.path))
        })

        this.item.roles = roles
      },
      deep: true,
    },
    imagePreview(newValue) {
      this.extraData.imagePreview = newValue
    },
  },
  methods: {
    imageToRemove(url) {
      this.extraData.imageToRemove = url
    },

    removeSelectedRole(role) {
      const index = this.selectedRoles.indexOf(role)
      if (index > -1) {
        this.selectedRoles.splice(index, 1)
      }
    },
    nameForRole(role) {
      const product = this.clickworkProducts.filter(
        (pr) => pr.productPath === role.productRef.path
      )[0]
      return `${product.name} ${
        role.name === 'product-admin' ? 'Admin' : 'Viewer'
      }`
    },
    productForSubscription(productRef) {
      return this.clickworkProducts.filter((pr) => {
        return pr.productPath === productRef.path
      })[0]
    },
    rolesForProduct(product) {
      return this.companyRoles.filter(
        (role) =>
          role.productRef && role.productRef?.path === product.productPath
      )
    },
    adminRoleForProduct(product) {
      return this.rolesForProduct(product).filter(
        (role) => role.name === 'product-admin'
      )[0]
    },
    viewerRoleForProduct(product) {
      return this.rolesForProduct(product).filter(
        (role) => role.name === 'product-user'
      )[0]
    },
    getDependencyRoles(mainRole) {
      const roles = []
      if (mainRole.dependencyRoles) {
        mainRole.dependencyRoles.forEach((depRoleRef) => {
          const role = this.companyRoles.filter(
            (role) =>
              role.defaultRoleRef &&
              role.defaultRoleRef.path === depRoleRef.path
          )[0]
          if (role) {
            roles.push(role)
          }
        })
      }
      return roles
    },

    adminRoleForSubscription(prodRef) {
      return this.adminRoleForProduct(this.productForSubscription(prodRef))
    },
    viewerRoleForSubscription(prodRef) {
      return this.viewerRoleForProduct(this.productForSubscription(prodRef))
    },
    getRoleParentDependency(role) {
      for (let sRole of this.selectedRoles) {
        if (
          sRole.dependencyRoles
            ?.map((r) => r.path)
            .includes(role.defaultRoleRef.path)
        ) {
          return sRole
        }
      }
      return undefined
    },
    roleHasSelectedParentDependency(role) {
      return this.getRoleParentDependency(role) !== undefined
    },
  },
}
</script>
